export const PARAMS = {
  USER_ID: 'userID',
  LOGIN_ID: 'loginID',
  TRADING_ACCOUNT_ID: 'tradingAccountId',
  MARKET_ID: 'marketID',
  CURRENCY_ID: 'currencyID',
  INSTRUMENT_ID: 'instrumentID',
  IGNORE_ZERO_TRADABLE_QTY: 'ignoreZeroTradableQty',
  LIMIT: 'limit',
  SHOW_DETAILS: 'showDetails',
  TRADING_ACC_SEQ: 'tradingAccSeq',
  DESTINATION: 'dest',
  TOKEN: 'token',
  KEY: 'key',
  OTP: 'otp',
  LANGUAGE: 'language',
  EMAIL: 'email',
  PHONE: 'phone',
  USER_NAME: 'username',
  PASSWORD: 'passwd',
  OTP_PASSWORD:'password',
  CAPTCHA: 'captcha',
  FULL_NAME: 'fullname',
  LOGIN_DEVICE: 'deviceName',
  LOGIN_IP: 'loginIP',
  SECRET_KEY: 'secretKey',
  DEVICE: 'device',
  DEVICE_ID: 'deviceID',
  NEW_PASSWORD: 'newPasswd',
  CONFIRM_PASSWORD: 'confirmPasswd',
  TRADING_ACCOUNT: 'tradingAccount',
  BANK_ACCOUNT_NAME:'bankAccountName',
  SERVICE: 'service',
  CLIENT_ID: 'clientID',
  TRADING_ACCOUNT_SEQ: 'tradingAccSeq',
  TRAN_TYPE: 'tranType',
  START_DATE: 'startDate',
  FROM_DATE: 'fromDate',
  END_DATE: 'endDate',
  TO_DATE: 'toDate',
  NICK: 'nick',
  REGION: 'region',
  ID: 'id',
  TIME_ZONE: 'timezone',
  AVATAR: 'avatar',
  ENTITLEMENT_ID: 'entitlementID',
  SUBSCRIPTION_ID: 'subscriptionID',
  LOT_SPREAD_DETAIL: 'lotSpreadDetail',
  CALCULATE_FEE_FLAG: 'calculateFeeFlag',
  QTY: 'qty',
  IPO_MARGIN: 'ipoMargin',
  CONTACT_EMAIL: 'contactEmail',
  CONTACT_NUMBER: 'contactNumber',
  RECEIVE_SMS: 'receiveSMS',
  SMS_LANGUAGE: 'SMSLanguage',
  FINANCING_PLAN: 'financingPlan',
  LENDING_PERCENTAGE: 'lendingPercentage',
  INTEREST_RATE_BASIS: 'interestRateBasis',
  INTEREST_RATE: 'interestRate',
  EXERCISE_QTY: 'exerciseQty',
  EXCESS_QTY: 'excessQty',
  WHOLLY_IN_STOCK_FLAG: 'whollyInStockFlag',
  SHOW_COUNT_ONLY: 'showcountOnly',
  BOOK_CLOSE_QTY_IN_SCRIP: 'bookCloseQtyInScrip',
  FIXED_CHARGE: 'fixedCharge',
  CHANNEL_ID: 'channelID',
  EVENT_TYPE: 'eventType',
  ACTION: 'action',
  REF_ID: 'refID',
  STATUS: 'status',
  SPREAD_TABLE_CODE: 'spreadTableCode',
  ORDER_GROUP_ID: 'orderGroupID',
  BS: 'BS',
  ORDER_TYPE: 'orderType',
  PRICE: 'price',
  ORDER_ID: 'orderID',
  GOOD_TILL_DATE: 'goodTillDate',
  NEW_QTY: 'newQty',
  NEW_PRICE: 'newPrice',
  SESSION_ID: 'sessid',
  SESSION_NAME: 'session_name',
  STOP_TYPE: 'stopType',
  STOP_PRICE: 'stopPrice',
  OTP_CODE: 'OTP',
  CAPTCHA_VERIFICATION: 'captchaVerification',
  ACCOUNT_TYPE: 'accountType',
  STATEMENT_TYPE: 'statementType',
  PERIOD: 'period',
  STATEMENT_DATE: 'statementDate',
  OPERATION: 'operation',
  AMOUNT: 'amount',
  SETTLEMETHOD: 'settleMethod',
  REMARK: 'remark',
  PAGEID: 'pageID',
  TRANSACTION_TYPE: 'transactionType',
  BANKACCOUNT: 'bankAccount',
  INSTRUCTIONID: 'instructionID',
  BANKID: 'bankID',
  FROM_CURRENCY: 'fromCurrency',
  TO_CURRENCY: 'toCurrency',
  FROM_AMOUNT: 'fromAmount',
  TO_AMOUNT: 'toAmount',
  IS_RESUBMIT:'isResubmit',
  STATEMENTREMARK:'statementRemark',
  GET_EXECUTED_DETAILS:'getExecutedDetails',
  GET_AUDIT_DETAIL: 'getAuditDetails',
  GET_EXECUTE_DETAIL: 'getExecutedDetails',
  MESSAGE_ID: 'messageID',
  IS_RESUBMIT: 'isResubmit',
  AASTOCK_USER_ID: 'aastockUserId',
  LOAN_AMOUNT: 'loanAmount',
  PASSWORD_ENCRYPT: 'passwordEncrypt',
  RANDOM_CODE: 'randomCode',
  VALUE: 'value',
  EXCHANGE_RATE: 'exchangeRate',
  FROM_BANKID: 'fromBankID',
  TO_BANKID: 'toBankID',
  FROM_BANKACCTID: 'fromBankAcctID',
  TO_BANKACCTID: 'toBankAcctID',
  DEVICE_TYPE: 'deviceType',
  INSTRUMENTNAME: 'instrumentName',
  INSTRUMENTSHORTNAME: 'instrumentShortname',
  INSTRUMENT_CHINESE_SHORT_NAME: 'instrumentChineseShortName',
  INSTRUMENT_CHINESE_NAME: 'instrumentChineseName',
  MINOFFERPRICE: 'minOfferPrice',
  MAXOFFERPRICE: 'maxOfferPrice',
  REFRESH_SESSION: 'refreshSession',
  APPLIEDQTY: 'appliedQty',
  OTP_TICKET: 'OTPTicket',
  CLIENT_THEME: 'client_theme',
  MARKET_COMMENT_POST:"node_posts_instrument",
  MARKET_COMMENT_REPORT_POST:"node-node_posts",
  MARKET_COMMENT_REPORT_COMMENT:"comment-comment_node_node_posts",
  NO_NEED_REDUX:'no_need_redux',
  SUB_ACCOUNT_ID: "subAccountID",
  PARAMETER_LIST: "parameterList"
}
